module.exports = __webpack_public_path__ + "img/calendar-check-01.ba9fe714.svg";